import React from 'react';
import { connect } from 'react-redux';
import remove from 'lodash/remove';

import { TreeSelector } from 'redpoints-front-components/index';

import {
  allIncidentsFiltersSetIncidentStatus,
  allIncidentsFiltersSetIncidentStatusGroup,
} from '../../../actions/allIncidentsActions';
import {
  getAllIncidentsFiltersIncidentStatusGroupSelected,
  getAllIncidentsFiltersIncidentStatusSelected,
  getAllIncidentsFiltersIncidentStatusTreeData,
} from '../../../reducers/reporting/allIncidents';
import { REPORT_TYPE } from './AllIncidents';
import { translate } from '../../../helpers/languageHelper';
import { getTreeKeysSelected } from './formDataHelpers';

const AllIncidentsFiltersIncidentStatus = ({
  allIncidentsFiltersSetIncidentStatus,
  allIncidentsFiltersSetIncidentStatusGroup,
  incidentStatusGroupSelected,
  incidentStatusSelected,
  incidentsStatusTreeData,
  reportType,
}) => {
  const STATUS_GROUP_REMOVE = {
    [REPORT_TYPE.CUSTOMER]: 'incidentStatusGroup_8',
  };

  const handleOnFilterChange = values => {
    const output = {};

    (values || []).forEach(value => {
      const [type, typeId] = value.split('_');
      output[type] = [...(output[type] || []), typeId];
    });

    allIncidentsFiltersSetIncidentStatusGroup({
      incidentStatusGroupId: output['incidentStatusGroup'],
    });
    allIncidentsFiltersSetIncidentStatus({
      incidentStatus: output['incidentStatus'],
    });
  };

  if (reportType === REPORT_TYPE.CUSTOMER) {
    remove(
      incidentsStatusTreeData,
      group => group.value === STATUS_GROUP_REMOVE[REPORT_TYPE.CUSTOMER]
    );
  }

  return (
    <TreeSelector
      aria-label="incident-status"
      className="incident-status-tree"
      label={translate('reporting.allIncidentsInternal.filters.incidentStatus')}
      treeData={incidentsStatusTreeData}
      onChange={handleOnFilterChange}
      value={getTreeKeysSelected({
        incidentStatus: incidentStatusSelected,
        incidentStatusGroup: incidentStatusGroupSelected,
      })}
      placeholder={translate('common.all')}
    />
  );
};

const mapStateToProps = state => ({
  incidentStatusGroupSelected: getAllIncidentsFiltersIncidentStatusGroupSelected(
    state
  ),
  incidentsStatusTreeData: getAllIncidentsFiltersIncidentStatusTreeData(state),
  incidentStatusSelected: getAllIncidentsFiltersIncidentStatusSelected(state),
});

export default connect(mapStateToProps, {
  allIncidentsFiltersSetIncidentStatus,
  allIncidentsFiltersSetIncidentStatusGroup,
})(AllIncidentsFiltersIncidentStatus);
